import _extends from "@babel/runtime/helpers/extends";
import { groupErrorsByTarget } from '@wix/form-validator';
import { formFieldFocus } from '@wix/bi-logger-forms-platform-uou/v2';
import React, { useCallback, useMemo } from 'react';
import { useExternalData } from '../../contexts/external-data-context';
import { useFormFields } from '../../contexts/form-fields-context';
import { useBi } from '../../../../contexts/bi-context';
import { useFieldValidation } from '../../../../contexts/field-validation-context';
import { useForm } from '../../../../contexts/form-context';
export const InputField = _ref => {
  let {
    field,
    errors,
    values,
    onFieldChange,
    FieldLayout
  } = _ref;
  const bi = useBi();
  const componentsById = useFormFields();
  const externalData = useExternalData();
  const {
    validateFields
  } = useFieldValidation();
  const form = useForm();
  const fieldValue = values[field.target];
  const errorsByTarget = useMemo(() => groupErrorsByTarget(errors), [errors]);
  const fieldErrors = errorsByTarget == null ? void 0 : errorsByTarget[field.target];
  const fieldError = fieldErrors == null ? void 0 : fieldErrors[0];
  const {
    requiredIndicator,
    requiredIndicatorPlacement
  } = form.requiredIndicatorProperties || {};
  const _onBlur = () => {
    bi == null || bi.report(formFieldFocus({
      action_type: 'blur',
      field_id: field.id,
      field_label: field.properties.label,
      field_target: field == null ? void 0 : field.target
    }));
    validateFields([{
      value: fieldValue,
      path: field.path
    }]);
  };
  const _onFocus = () => {
    bi == null || bi.report(formFieldFocus({
      action_type: 'focus',
      field_id: field.id,
      field_label: field.properties.label,
      field_target: field == null ? void 0 : field.target
    }));
  };
  const handleChange = useCallback(value => {
    if (fieldError) {
      validateFields([{
        value,
        path: field.path
      }]);
    }
    if (!value && value !== 0 && typeof value !== 'boolean' || Array.isArray(value) && value.length === 0) {
      value = null;
    }
    onFieldChange == null || onFieldChange(field.target, value);
  }, [onFieldChange, field, fieldError, validateFields]);
  const FieldComponent = componentsById[field.fieldType];
  if (!FieldComponent) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FieldComponent, _extends({}, field.properties, {
    onChange: handleChange,
    onBlur: _onBlur,
    onFocus: _onFocus,
    error: fieldError,
    errors: fieldErrors,
    value: fieldValue,
    id: field.id,
    target: field.target,
    path: field.path,
    externalData: externalData,
    fieldType: field.fieldType,
    FieldLayout: FieldLayout,
    requiredIndicatorType: requiredIndicator,
    requiredIndicatorPlacement: requiredIndicatorPlacement
  }));
};
//# sourceMappingURL=input-field.js.map